import MaterialIcon from '@components/common/MaterialIcon';
import clsx from 'clsx';
import type React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  className?: string;
  // Inherit the colour of a checklist table row, which already carries the redirect cyan.
  muted?: boolean;
};

// Takes the place of the answer for a question an Intent Check sent to a flow the A.I.
// does not answer - a route icon instead of the bot icon, so it never reads as an answer,
// in the redirect cyan used for the checklist row and the review card.
export const IntentRedirectLabel: React.FC<Props> = ({
  className,
  muted = false,
}) => {
  const { t } = useTranslation();

  return (
    <span
      title={t('train-ai.intent-redirect.tooltip')}
      className={clsx(
        'flex items-start gap-2 text-tiny italic',
        !muted && 'text-cyan-800',
        className,
      )}>
      <MaterialIcon
        icon='alt_route'
        type='outlined'
        classes={[
          'text-sm',
          muted ? 'text-inherit' : 'text-cyan-700',
          'mt-0.5',
          '!leading-none',
        ]}
      />
      <span>{t('train-ai.intent-redirect.label')}</span>
    </span>
  );
};
